import { render, staticRenderFns } from "./DeleteTagModal.vue?vue&type=template&id=20a3fd44&scoped=true"
import script from "./DeleteTagModal.vue?vue&type=script&lang=js"
export * from "./DeleteTagModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a3fd44",
  null
  
)

export default component.exports